import { Box, Typography } from '@mui/material'
import PropTypes from 'prop-types'

const Subtitle = (props) => {
  const { children, variant = 'h2', ...rest } = props
  return children ? (
    variant === 'div' ? (
      <Box {...rest}>{children}</Box>
    ) : (
      <Typography variant={variant} gutterBottom {...rest}>
        {children}
      </Typography>
    )
  ) : null
}

Subtitle.propTypes = {
  variant: PropTypes.string,
}

export default Subtitle
